export const modalConstants = {
  REDIRECT: 'REDIRECT',
  LOGIN: 'LOGIN',
  HIDE: 'MODAL_HIDE',
  USER_PROFILE_ONBOARDING: 'USER_PROFILE_ONBOARDING',
  USER_LOCATION_ONBOARDING: 'USER_LOCATION_ONBOARDING',
  NPS: 'NPS',
  LAST_MINUTE: 'LAST_MINUTE',
  REVIEWS: 'REVIEWS_MODAL',
  ADD_REVIEWS_PREV_STATE: 'MODAL_REVIEWS_ADD_PREV_STATE',
  REMOVE_REVIEWS_PREV_STATE: 'MODAL_REVIEWS_REMOVE_PREV_STATE',
  RESET_REVIEWS_PREV_STATE: 'MODAL_REVIEWS_RESET_PREV_STATE',
};
